/**
 * Etiquetas i18n de la ficha de un pack (shared/partnerships-package-sheet.ts), compartidas
 * por el detalle y el formulario: un solo lugar para que las claves no diverjan.
 */
import type { useTranslation } from 'react-i18next';
import { PACKAGE_SHEET_ENUM_LABELS, type PackageSheetField, type PackageSheetSection } from '../../../../shared/partnerships-package-sheet';

type T = ReturnType<typeof useTranslation>['t'];

export const sectionTitle = (t: T, s: PackageSheetSection) => t(`partnerships.package_sheet.sections.${s.key}`, { defaultValue: s.label });
export const fieldLabel = (t: T, f: PackageSheetField) => t(`partnerships.package_sheet.fields.${f.key}`, { defaultValue: f.label });
export const fieldHelp = (t: T, f: PackageSheetField) => (f.help ? t(`partnerships.package_sheet.help.${f.key}`, { defaultValue: f.help }) : '');
export const enumLabel = (t: T, v: string) => t(`partnerships.package_sheet.enums.${v}`, { defaultValue: PACKAGE_SHEET_ENUM_LABELS[v] ?? v });
